import { render, staticRenderFns } from "./customSelectBox.vue?vue&type=template&id=2199f0d7"
import script from "./customSelectBox.vue?vue&type=script&lang=js"
export * from "./customSelectBox.vue?vue&type=script&lang=js"
import style0 from "./customSelectBox.vue?vue&type=style&index=0&id=2199f0d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports